module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contribute-copyrights-icon-a50b06a9702bbafd0aef4588383b3a72.png";